import React from 'react';
import { useTheme } from '../../context/ThemeContext';

export default function ThemePicker() {
  const { selectTheme, themes } = useTheme();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0a0f1e 0%, #1a2235 50%, #0a1628 100%)',
      fontFamily: "'Rajdhani', sans-serif",
    }}>
      <div style={{ textAlign: 'center', animation: 'fadeIn 0.5s ease' }}>
        <div style={{ marginBottom: '2rem' }}>
          <h1 style={{
            fontSize: '3rem', fontWeight: 700, letterSpacing: '4px',
            background: 'linear-gradient(135deg, #00d4ff, #00e5a0)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            marginBottom: '0.5rem',
          }}>VITALFORGE</h1>
          <p style={{ color: '#8899bb', letterSpacing: '2px', fontSize: '0.9rem' }}>
            YOUR HEALTH. FORGED DAILY.
          </p>
        </div>

        <p style={{ color: '#8899bb', marginBottom: '2rem', fontFamily: "'Exo 2', sans-serif" }}>
          Choose your interface theme
        </p>

        <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {Object.values(themes).map(t => (
            <button
              key={t.name}
              onClick={() => selectTheme(t.name)}
              style={{
                width: '180px', padding: '2rem 1.5rem',
                background: t.bgCard, border: `2px solid ${t.border}`,
                borderRadius: '16px', cursor: 'pointer',
                transition: 'all 0.2s ease', color: t.text,
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = t.accent;
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = `0 12px 40px ${t.accent}33`;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = t.border;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{
                width: '48px', height: '48px', borderRadius: '50%',
                background: `linear-gradient(135deg, ${t.accent}, ${t.success})`,
                margin: '0 auto 1rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {t.name === 'dark' ? '🌙' : '☀️'}
              </div>
              <div style={{ fontFamily: "'Rajdhani', sans-serif", fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.25rem' }}>
                {t.label}
              </div>
              <div style={{ fontSize: '0.75rem', color: t.textSecondary, fontFamily: "'Exo 2', sans-serif" }}>
                {t.name === 'dark' ? 'Deep navy · Steel · Neon' : 'Soft white · Baby blue · Fresh'}
              </div>
            </button>
          ))}
        </div>

        <p style={{ color: '#445566', marginTop: '2rem', fontSize: '0.8rem', fontFamily: "'Exo 2', sans-serif" }}>
          You can change this anytime in settings
        </p>
      </div>
    </div>
  );
}
